// Case Timeline Builder event categories — single source of truth, consumed by
// the event editor's category picker, the on-screen list/overview map, and the
// PDF export's legend/badges. Mirrors the CONTACT_OUTCOMES/REVIEW_RESULTS
// convention already used by the Video Canvass Tracker.

export const EVENT_CATEGORIES = [
  { value: 'call_text', label: 'Call/Text', color: '#4f46e5' },
  { value: 'interview', label: 'Interview', color: '#0891b2' },
  { value: 'video_photo', label: 'Video/Photo', color: '#6d28d9' },
  { value: 'report', label: 'Report', color: '#64748b' },
  { value: 'lpr_vehicle', label: 'LPR/Vehicle', color: '#16a34a' },
  { value: 'financial', label: 'Financial', color: '#f59e0b' },
  { value: 'other', label: 'Other', color: '#94a3b8' },
];

export function categoryInfo(value) {
  return EVENT_CATEGORIES.find(c => c.value === value) || EVENT_CATEGORIES[EVENT_CATEGORIES.length - 1];
}
